import { Expose, Type } from 'class-transformer';

import { Default, ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { CameraStreamConfigs, CameraStreamConfigsMap } from './camera-stream-configs';

export class SnCapacity extends SnModel {
  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }

  @Expose()
  public applianceId: string;

  @Expose()
  @Default('Unknown')
  public capacityStatus: string;

  @Expose()
  @Type(() => Date)
  public capacityStatusUpdatedAt: Date;

  @Expose()
  public currentStreamingBandwidth: number; // in bps

  @Expose()
  public totalBandwidthCapacity: number; // in bps

  @Expose()
  public currentStorageUsage: number; // in bytes

  @Expose()
  public totalStorageCapacity: number; // in bytes

  @Expose()
  public currentTemperature: number; // in fahrenheit

  @Expose()
  public networkUploadSpeed: number; // in mbps

  @Expose()
  @Type(() => Date)
  public networkSpeedUpdatedAt: Date;

  @ExposeRawData()
  @Type(() => CameraStreamConfigs)
  public cameraStreamConfigs: CameraStreamConfigsMap;
}
